var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.$t('wifi.connect')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }